import { api } from "./axios";

export const getAdminBookingOptions = () =>
  api.get("/admin/booking-options");

export const createBookingOption = (payload) =>
  api.post("/admin/booking-options", payload);

export const updateBookingOption = (id, payload) =>
  api.put(`/admin/booking-options/${id}`, payload);

export const deleteBookingOption = (id) =>
  api.delete(`/admin/booking-options/${id}`);